import { Component } from 'react'
import { TextField } from 'beam/dist/TextField'
import fieldPropTypes from './FieldPropTypes'
import PropTypes from 'prop-types'
import { get } from 'lodash'

class FormSelectField extends Component {
  handleSelectBlur = () => {
    const {
      form,
      field: { name },
    } = this.props
    form.setFieldTouched(name, true)
  }

  render() {
    const {
      label,
      field,
      required,
      showErrorBeforeTouched,
      fullWidth,
      classes,
      selectProps,
      selectFieldProps,
      form: { errors, touched },
      children,
    } = this.props

    return (
      <TextField
        select
        {...field}
        value={field.value || ''}
        InputLabelProps={{
          htmlFor: field.name,
        }}
        inputProps={{
          id: field.name,
        }}
        label={label}
        required={required}
        onBlur={this.handleSelectBlur}
        onChange={e => {
          field.onChange(e)
          this.props.onChange && this.props.onChange(e)
        }}
        error={(!!showErrorBeforeTouched || !!get(touched, field.name)) && !!get(errors, field.name)}
        helperText={(!!showErrorBeforeTouched || !!get(touched, field.name)) && get(errors, field.name)}
        fullWidth={fullWidth}
        classes={classes}
        SelectProps={{
          ...selectProps,
          MenuProps: {
            variant: 'menu', // this prop is needed to prevent a new, unwanted behavior from Material-UI
            ...(selectProps || {}).MenuProps,
          },
        }}
        {...selectFieldProps}
      >
        {children}
      </TextField>
    )
  }
}

const selectPropTypes = {
  ...fieldPropTypes,
  selectProps: PropTypes.object,
  selectFieldProps: PropTypes.object,
}
FormSelectField.propTypes = selectPropTypes
FormSelectField.defaultProps = {
  fullWidth: true,
}

export default FormSelectField
